import Vue from 'vue'
import LibPhonenumber from 'google-libphonenumber'

const emailRE = /^[a-z0-9_\-.]+@[a-z0-9_\-.]+\.[a-z]{2,6}$/i

// normalizeNumber will return a phone number in E164 format, which is used in the back end.
const normalizeNumber = function (n, region) {
  try {
    // If we entered the number itself with a zero, the formatting below won't remove it. We'll do that ourselves.
    if (n[0] === '0') {
      n = n.substr(1)
    }
    let number = LibPhonenumber.PhoneNumberUtil.getInstance().parseAndKeepRawInput(n, region.region)
    return LibPhonenumber.PhoneNumberUtil.getInstance().format(number, LibPhonenumber.PhoneNumberFormat.E164)
  } catch (e) {}
  return n
}

function buildOrderItem (cartItem, isSingle) {
  return {
    id: cartItem.id,
    product: {
      id: cartItem.product ? cartItem.product.id : cartItem.id,
      category: cartItem.product ? cartItem.product.category : 'poster' // needed for VAT calculations
    },
    subtotalIncVat: isSingle ? cartItem.price.amount : cartItem.count * cartItem.price.amount,
    totalIncVat: isSingle ? cartItem.price.amount : cartItem.count * cartItem.price.amount,
    quantity: isSingle ? 1 : cartItem.count,
    options: cartItem.product ? cartItem.options : {
      childName: cartItem.childName,
      birthDate: cartItem.birthDate,
      birthTime: cartItem.birthTime,
      length: cartItem.length,
      weight: cartItem.weight,
      presentation: cartItem.presentation,
      color: cartItem.color
    }
  }
}

// Shipping methods.
const shippingMethods = {
  // Regular postal shipping, always free.
  standard: {
    method: 'standard',
    name: '',
    prices: {
      SEK: 0,
      DKK: 0,
      EUR: 0,
      USD: 0,
      AUD: 0
    },
    deliveryDaysMin: 3,
    deliveryDaysMax: 8,
    hasTracking: false
  },

  // Express shipping with DHL.
  express: {
    method: 'express',
    name: 'DHL',
    prices: {
      SEK: 20000,
      DKK: 20000,
      EUR: 2000,
      USD: 2500,
      AUD: 3500
    },
    deliveryDaysMin: 3,
    deliveryDaysMax: 4,
    hasTracking: true
  }
}

// VAT percentages, based on shipping country.
const vatValues = {
  'be': {
    giftCard: 0,
    default: 0.25
  },
  'gr': {
    giftCard: 0,
    default: 0.25
  },
  'lt': {
    giftCard: 0,
    default: 0.25
  },
  'pt': {
    giftCard: 0,
    default: 0.25
  },
  'bg': {
    giftCard: 0,
    default: 0.25
  },
  'es': {
    giftCard: 0,
    default: 0.25
  },
  'lu': {
    giftCard: 0,
    default: 0.25
  },
  'ro': {
    giftCard: 0,
    default: 0.25
  },
  'cz': {
    giftCard: 0,
    default: 0.25
  },
  'fr': {
    giftCard: 0,
    default: 0.25
  },
  'hu': {
    giftCard: 0,
    default: 0.25
  },
  'si': {
    giftCard: 0,
    default: 0.25
  },
  'dk': {
    giftCard: 0,
    default: 0.25
  },
  'hr': {
    giftCard: 0,
    default: 0.25
  },
  'mt': {
    giftCard: 0,
    default: 0.25
  },
  'sk': {
    giftCard: 0,
    default: 0.25
  },
  'de': {
    giftCard: 0,
    default: 0.25
  },
  'it': {
    giftCard: 0,
    default: 0.25
  },
  'nl': {
    giftCard: 0,
    default: 0.25
  },
  'fi': {
    giftCard: 0,
    default: 0.25
  },
  'ee': {
    giftCard: 0,
    default: 0.25
  },
  'cy': {
    giftCard: 0,
    default: 0.25
  },
  'at': {
    giftCard: 0,
    default: 0.25
  },
  'se': {
    giftCard: 0,
    default: 0.25
  },
  'ie': {
    giftCard: 0,
    default: 0.25
  },
  'lv': {
    giftCard: 0,
    default: 0.25
  },
  'pl': {
    giftCard: 0,
    default: 0.25
  },
  'gb': {
    giftCard: 0,
    default: 0.25
  }
}

const voucher = {
  isValid: false
}

const giftCard = {
  isValid: false
}

// @todo Implement voucher.
export default {
  strict: true,

  state: {
    // Order info
    email: '',
    firstName: '',
    lastName: '',
    phoneMobile: '',
    phoneMobileRegion: {
      region: 'SE',
      prefix: '+46'
    },
    address: '',
    city: '',
    country: 'SE',
    state: '',
    postalCode: '',
    rememberMe: false,

    // Separate delivery address
    separateDeliveryAddress: false,
    deliveryEmail: '',
    deliveryPhoneMobile: '',
    deliveryPhoneMobileRegion: {
      region: 'SE',
      prefix: '+46'
    },
    deliveryFirstName: '',
    deliveryLastName: '',
    deliveryAddress: '',
    deliveryCity: '',
    deliveryCountry: 'SE',
    deliveryState: '',
    deliveryPostalCode: '',

    // Shipping
    shippingMethod: '',

    // Voucher
    voucher: voucher,

    // Gift card
    giftCard: giftCard,

    // Order confirmation
    orderState: 'creatingOrder',
    orderId: '',
    orderConfirmationNumber: '-',
    orderPaymentSourceLast4: '-',
    orderPaymentSourceBrand: '-',

    isCountrySet: false
  },

  mutations: {
    SET_VOUCHER (state, voucher) {
      state.voucher = voucher
    },

    SET_GIFT_CARD (state, giftCard) {
      state.giftCard = giftCard
    },

    SET_EMAIL (state, email) {
      state.email = email
    },

    SET_FIRST_NAME (state, firstName) {
      state.firstName = firstName
    },

    SET_LAST_NAME (state, lastName) {
      state.lastName = lastName
    },

    SET_PHONE_MOBILE (state, phoneMobile) {
      state.phoneMobile = phoneMobile
    },

    SET_PHONE_MOBILE_REGION (state, region) {
      state.phoneMobileRegion = region
    },

    SET_ADDRESS (state, address) {
      state.address = address
    },

    SET_CITY (state, city) {
      state.city = city
    },

    SET_COUNTRY (state, country) {
      state.country = country
    },

    SET_STATE (state, s) {
      state.state = s
    },

    SET_POSTAL_CODE (state, postalCode) {
      state.postalCode = postalCode
    },

    SET_DELIVERY_EMAIL (state, email) {
      state.deliveryEmail = email
    },

    SET_DELIVERY_PHONE_MOBILE (state, phoneMobile) {
      state.deliveryPhoneMobile = phoneMobile
    },

    SET_DELIVERY_PHONE_MOBILE_REGION (state, region) {
      state.deliveryPhoneMobileRegion = region
    },

    SET_DELIVERY_FIRST_NAME (state, name) {
      state.deliveryFirstName = name
    },

    SET_DELIVERY_LAST_NAME (state, name) {
      state.deliveryLastName = name
    },

    SET_SEPARATE_DELIVERY_ADDRESS (state, useSeparateDeliveryAddress) {
      state.separateDeliveryAddress = useSeparateDeliveryAddress
    },

    SET_REMEMBER_ME (state, rememberMe) {
      state.rememberMe = rememberMe
    },

    SET_DELIVERY_ADDRESS (state, deliveryAddress) {
      state.deliveryAddress = deliveryAddress
    },

    SET_DELIVERY_CITY (state, deliveryCity) {
      state.deliveryCity = deliveryCity
    },

    SET_DELIVERY_COUNTRY (state, deliveryCountry) {
      state.deliveryCountry = deliveryCountry
    },

    SET_DELIVERY_STATE (state, deliveryState) {
      state.deliveryState = deliveryState
    },

    SET_DELIVERY_POSTAL_CODE (state, deliveryPostalCode) {
      state.deliveryPostalCode = deliveryPostalCode
    },

    SET_SHIPPING_METHOD (state, shippingMethod) {
      state.shippingMethod = shippingMethod
    },

    SET_ORDER_STATE (state, orderState) {
      state.orderState = orderState
    },

    SET_ORDER_ID (state, id) {
      state.orderId = id
    },

    SET_ORDER_CONFIRMATION_NUMBER (state, confirmationNumber) {
      state.orderConfirmationNumber = confirmationNumber
    },

    SET_ORDER_PAYMENT_SOURCE_LAST4 (state, last4) {
      state.orderPaymentSourceLast4 = last4
    },

    SET_ORDER_PAYMENT_SOURCE_BRAND (state, brand) {
      state.orderPaymentSourceBrand = brand
    },

    SET_IS_COUNTRY_SET (state, isCountrySet) {
      state.isCountrySet = isCountrySet
    },

    CLEAR_VOUCHER (state) {
      // Voucher should always be cleared.
      state.voucher = voucher
    },

    CLEAR_GIFT_CARD (state) {
      state.giftCard = giftCard
    },

    // CLEAR_SOFT is named as such because it respects the remember-me flag.
    CLEAR_SOFT (state, force) {
      // Don't clear the checkout form if we've checked "remember me".
      if (!force && state.rememberMe) {
        return
      }

      state.rememberMe = false

      // Order info
      state.email = ''
      state.firstName = ''
      state.lastName = ''
      state.phoneMobile = ''
      state.phoneMobileRegion = {
        region: 'SE',
        prefix: '+46'
      }
      state.address = ''
      state.city = ''
      state.country = 'SE'
      state.state = ''
      state.postalCode = ''

      // Separate delivery address
      state.separateDeliveryAddress = false
      state.deliveryEmail = ''
      state.deliveryPhoneMobile = ''
      state.deliveryPhoneMobileRegion = {
        region: 'SE',
        prefix: '+46'
      }
      state.deliveryFirstName = ''
      state.deliveryLastName = ''
      state.deliveryAddress = ''
      state.deliveryCity = ''
      state.deliveryCountry = 'SE'
      state.deliveryState = ''
      state.deliveryPostalCode = ''

      // Shipping
      state.shippingMethod = ''

      // Order confirmation
      state.orderState = 'creatingOrder'
      state.orderId = ''
      state.orderConfirmationNumber = '-'
      state.orderPaymentSourceLast4 = '-'
      state.orderPaymentSourceBrand = '-'

      state.isCountrySet = false
    }
  },

  actions: {
    // START SETTERS
    addVoucher ({ commit, getters }, voucherCode) {
      commit('CLEAR_VOUCHER')
      return new Promise(function (resolve, reject) {
        Vue.http.get(process.env.API_URL + '/vouchers/check/' + voucherCode).then(function (response) {
          if (!response.body.isValid) {
            reject(response)
            return
          }
          if (['percentage', 'fixed_product', 'fixed_cart'].indexOf(response.body.discountType) < 0) {
            reject(response)
            return
          }
          let voucher = response.body
          if (Array.isArray(voucher.includeProducts)) {
            voucher.includeProducts = voucher.includeProducts.map(function (value) {
              return value.toLowerCase()
            })
          } else {
            voucher.includeProducts = []
          }
          if (Array.isArray(voucher.excludeProducts)) {
            voucher.excludeProducts = voucher.excludeProducts.map(function (value) {
              return value.toLowerCase()
            })
            voucher.excludeProducts = ['gft-0001', 'gft-0002', 'gft-0003', ...voucher.excludeProducts]
          } else {
            voucher.excludeProducts = ['gft-0001', 'gft-0002', 'gft-0003']
          }
          commit('SET_VOUCHER', voucher)
          resolve(response)
        }).catch(function (response) {
          reject(response)
        })
      })
    },

    clearVoucher ({ commit }) {
      commit('CLEAR_VOUCHER')
    },

    addGiftCard ({ commit, getters }, gitCardCode) {
      commit('CLEAR_GIFT_CARD')
      return new Promise(function (resolve, reject) {
        Vue.http.get(process.env.API_URL + '/vouchers/check/' + gitCardCode).then(function (response) {
          if (!response.body.isValid) {
            reject(response)
            return
          }
          if (['gift_card'].indexOf(response.body.discountType) < 0) {
            reject(response)
            return
          }
          let giftCard = response.body
          if (Array.isArray(giftCard.includeProducts)) {
            giftCard.includeProducts = giftCard.includeProducts.map(function (value) {
              return value.toLowerCase()
            })
          } else {
            giftCard.includeProducts = []
          }
          if (Array.isArray(giftCard.excludeProducts)) {
            giftCard.excludeProducts = giftCard.excludeProducts.map(function (value) {
              return value.toLowerCase()
            })
            giftCard.excludeProducts = ['gft-0001', 'gft-0002', 'gft-0003', ...giftCard.excludeProducts]
          } else {
            giftCard.excludeProducts = ['gft-0001', 'gft-0002', 'gft-0003']
          }
          commit('SET_GIFT_CARD', giftCard)
          resolve(response)
        }).catch(function (response) {
          reject(response)
        })
      })
    },

    clearGiftCard ({ commit }) {
      commit('CLEAR_GIFT_CARD')
    },

    setCheckoutEmail ({ commit }, email) {
      commit('SET_EMAIL', email)
    },

    setCheckoutFirstName ({ commit }, firstName) {
      commit('SET_FIRST_NAME', firstName)
    },

    setCheckoutLastName ({ commit }, lastName) {
      commit('SET_LAST_NAME', lastName)
    },

    // @todo LIBPHONENUMBER.
    setCheckoutPhoneMobile ({ commit }, phoneMobile) {
      // @todo Implement libphonenumber validation.
      commit('SET_PHONE_MOBILE', phoneMobile)
    },

    setCheckoutPhoneMobileRegion ({ commit }, region) {
      commit('SET_PHONE_MOBILE_REGION', region)
    },

    setCheckoutAddress ({ commit }, address) {
      commit('SET_ADDRESS', address)
    },

    setCheckoutCity ({ commit }, city) {
      commit('SET_CITY', city)
    },

    setCheckoutCountry ({ commit }, country) {
      commit('SET_COUNTRY', country)
    },

    setCheckoutState ({ commit }, state) {
      commit('SET_STATE', state)
    },

    setCheckoutPostalCode ({ commit }, postalCode) {
      commit('SET_POSTAL_CODE', postalCode)
    },

    setCheckoutSeparateDeliveryAddress ({ commit }, useSeparateDeliveryAddress) {
      commit('SET_SEPARATE_DELIVERY_ADDRESS', useSeparateDeliveryAddress)
    },

    setCheckoutRememberMe ({ commit }, rememberMe) {
      commit('SET_REMEMBER_ME', rememberMe)
    },

    setCheckoutDeliveryEmail ({ commit }, email) {
      commit('SET_DELIVERY_EMAIL', email)
    },

    setCheckoutDeliveryPhoneMobile ({ commit }, phoneNumber) {
      commit('SET_DELIVERY_PHONE_MOBILE', phoneNumber)
    },

    setCheckoutDeliveryPhoneMobileRegion ({ commit }, region) {
      commit('SET_DELIVERY_PHONE_MOBILE_REGION', region)
    },

    setCheckoutDeliveryFirstName ({ commit }, name) {
      commit('SET_DELIVERY_FIRST_NAME', name)
    },

    setCheckoutDeliveryLastName ({ commit }, name) {
      commit('SET_DELIVERY_LAST_NAME', name)
    },

    setCheckoutDeliveryAddress ({ commit }, deliveryAddress) {
      commit('SET_DELIVERY_ADDRESS', deliveryAddress)
    },

    setCheckoutDeliveryCity ({ commit }, deliveryCity) {
      commit('SET_DELIVERY_CITY', deliveryCity)
    },

    setCheckoutDeliveryCountry ({ commit }, deliveryCountry) {
      commit('SET_DELIVERY_COUNTRY', deliveryCountry)
    },

    setCheckoutDeliveryState ({ commit }, deliveryState) {
      commit('SET_DELIVERY_STATE', deliveryState)
    },

    setCheckoutDeliveryPostalCode ({ commit }, deliveryPostalCode) {
      commit('SET_DELIVERY_POSTAL_CODE', deliveryPostalCode)
    },

    setCheckoutShippingMethod ({ commit }, shippingMethod) {
      commit('SET_SHIPPING_METHOD', shippingMethod)
    },

    // END SETTERS, START ORDER HANDLING

    // createOrder will create the order in the back end. Payment etc is handled below.
    createOrder ({ commit, state, getters }) {
      // Set up billing object.
      let billingDestination = {
        address: {
          name: state.firstName + ' ' + state.lastName,
          firstName: state.firstName,
          lastName: state.lastName,
          phone: normalizeNumber(state.phoneMobile, state.phoneMobileRegion),
          email: state.email,
          street: state.address,
          careOf: '',
          city: state.city,
          postalCode: state.postalCode,
          state: state.state,
          countryCode: state.country
        }
      }

      // Set up shipping object. The address field will be filled below, depending on if the customer wants a separate
      // delivery address or not.
      let shippingDestination = {
        address: {},
        method: getters.shippingMethod.method,
        costIncVat: getters.shippingCost
      }

      if (state.separateDeliveryAddress) {
        shippingDestination.address.name = state.deliveryFirstName + ' ' + state.deliveryLastName
        shippingDestination.address.firstName = state.deliveryFirstName
        shippingDestination.address.lastName = state.deliveryLastName
        shippingDestination.address.phone = normalizeNumber(state.deliveryPhoneMobile, state.deliveryPhoneMobileRegion)
        shippingDestination.address.email = state.deliveryEmail
        shippingDestination.address.street = state.deliveryAddress
        shippingDestination.address.careOf = '' // Not implemented
        shippingDestination.address.city = state.deliveryCity
        shippingDestination.address.postalCode = state.deliveryPostalCode
        shippingDestination.address.state = state.deliveryState
        shippingDestination.address.countryCode = state.deliveryCountry
      } else {
        shippingDestination.address.name = state.firstName + ' ' + state.lastName
        shippingDestination.address.firstName = state.firstName
        shippingDestination.address.lastName = state.lastName
        shippingDestination.address.phone = normalizeNumber(state.phoneMobile, state.phoneMobileRegion)
        shippingDestination.address.email = state.email
        shippingDestination.address.street = state.address
        shippingDestination.address.careOf = '' // @todo Implement.
        shippingDestination.address.city = state.city
        shippingDestination.address.postalCode = state.postalCode
        shippingDestination.address.state = state.state
        shippingDestination.address.countryCode = state.country
      }

      let payload = {
        items: getters.orderItems,
        countryCode: shippingDestination.address.countryCode,
        currencyCode: getters.currency.currency,
        customer: {
          name: state.firstName + ' ' + state.lastName,
          email: state.email,
          phone: normalizeNumber(state.phoneMobile, state.phoneMobileRegion)
        },
        billing: billingDestination,
        shipping: shippingDestination
      }

      if (getters.voucherIsApplicable === true) {
        payload.voucherCode = state.voucher.code
      }

      if (getters.giftCardEffectiveAmount > 0) {
        payload.giftCard = state.giftCard.code
      }

      return Vue.http.post(process.env.API_URL + '/orders', payload)
    },

    updateOrder ({ commit, state, getters }) {
      let payload = {
        items: getters.orderItems
      }

      if (getters.voucherIsApplicable === true) {
        payload.voucherCode = state.voucher.code
      }

      if (getters.giftCardEffectiveAmount > 0) {
        payload.giftCard = state.giftCard.code
      }

      return Vue.http.put(process.env.API_URL + '/orders/' + state.orderId, payload)
    },

    createQliroOrder ({ commit, state }, orderId) {
      return Vue.http.post(process.env.API_URL + '/qliro/' + orderId)
    },

    updateQliroOrder ({ commit, state, getters }) {
      /* eslint-disable */
      return Vue.http.put(process.env.API_URL + '/qliro/' + state.orderId)
      /* eslint-enable */
    },

    // obj will look like this:
    // { order, source }
    //
    // @see https://stripe.com/docs/sources/cards (Stripe source docs)
    payOrder ({ commit, state }, obj) {
      return Vue.http.post(process.env.API_URL + '/orders/' + obj.order.id + '/pay', obj)
    },

    getOrder ({ commit, state }, orderId) {
      return Vue.http.get(process.env.API_URL + '/orders/' + orderId)
    },

    syncOrder ({ commit, state }, orderId) {
      return Vue.http.post(process.env.API_URL + '/qliro/sync-order/' + orderId, {})
    },

    getCountryCode () {
      return new Promise(function (resolve, reject) {
        Vue.http.get('/cdn-cgi/trace').then(function (response) {
          const lines = response.data.split('\n')
          for (let index = 0; index < lines.length; index++) {
            const keyValue = lines[index].split('=')
            if (keyValue[0] === 'loc' && keyValue[1] !== 'XX') {
              const countryCode = decodeURIComponent(keyValue[1] || '')
              if (countryCode.toLowerCase() !== 'xx') {
                return resolve(countryCode)
              }
            }
          }
          reject(new Error('Unable to determine the country code.'))
        }).catch(function (err) {
          reject(err)
        })
      })
    },

    // setSVGs will take each order item and update the order with the SVG base 64.
    setSVGs ({ commit, state }, order) {
      const posterCartItems = []
      this.getters.cartItems.forEach((item) => {
        if (item.type) {
          if (item.type === 'poster') {
            posterCartItems.push(item)
          }
        } else {
          posterCartItems.push(item)
        }
      })
      return new Promise(function (resolve, reject) {
        if (posterCartItems.length > 0) {
          let cartItemsWithSVGs = []
          Vue.http.get(process.env.API_URL + '/orders/' + order.id + '/items').then(function (response) {
            let svgPromises = []
            response.body.forEach(function (orderItem) {
              if (orderItem.product.category === '' || orderItem.product.category === 'poster') {
                let cartItemIsFound = false
                posterCartItems.forEach(function (cartItem, key) {
                  if (!cartItemIsFound && !cartItemsWithSVGs.includes(key)) {
                    const productId = cartItem.product ? cartItem.product.id : cartItem.id
                    if (productId === orderItem.product.id &&
                      cartItem.count === orderItem.quantity &&
                      /* eslint-disable */
                      (cartItem.options && cartItem.options.childName === orderItem.options.childName || cartItem.childName === orderItem.options.childName) &&
                      (cartItem.options && cartItem.options.birthDate === orderItem.options.birthDate || cartItem.birthDate === orderItem.options.birthDate) &&
                      (cartItem.options && cartItem.options.birthTime === orderItem.options.birthTime || cartItem.birthTime === orderItem.options.birthTime) &&
                      (cartItem.options && cartItem.options.length === orderItem.options.length || cartItem.length === orderItem.options.length) &&
                      (cartItem.options && cartItem.options.weight === orderItem.options.weight || cartItem.weight === orderItem.options.weight) &&
                      (cartItem.options && cartItem.options.presentation === orderItem.options.presentation || cartItem.presentation === orderItem.options.presentation) &&
                      (cartItem.options && cartItem.options.color === orderItem.options.color || cartItem.color === orderItem.options.color)
                      /* eslint-enable */
                    ) {
                      cartItemIsFound = true
                      svgPromises.push(
                        Vue.http.post(process.env.API_URL + '/order-items/' + orderItem.id + '/svg', { svg: cartItem.svgB64 })
                      )
                      cartItemsWithSVGs.push(key)
                    }
                  }
                })
                if (!cartItemIsFound) {
                  reject(new Error('An order item could not be mapped to any of the cart items.'))
                }
              }
            })
            Promise.all(svgPromises).then(function (values) {
              resolve(values)
            }).catch(function (error) {
              reject(error)
            })
          }).catch(function (response) {
            reject(response)
          })
        } else {
          resolve()
        }
      })
    },

    // setOrderState sets the state to show to the customer. It is a simple text string which should have a translation
    // for the languages.
    //
    // It is used when the customer has finished inputting their info and clicked "pay". A modal then shows the state
    // as the sequential requests are being made.
    setOrderState ({ commit }, orderState) {
      commit('SET_ORDER_STATE', orderState)
    },

    // @todo Move. This should be internal to the checkout store.
    setOrderId ({ commit }, orderId) {
      commit('SET_ORDER_ID', orderId)
    },

    // @todo Move. This should be internal to the checkout store.
    setOrderConfirmationNumber ({ commit }, orderConfirmation) {
      commit('SET_ORDER_CONFIRMATION_NUMBER', orderConfirmation)
    },

    setOrderPaymentSourceLast4 ({ commit }, last4) {
      if (typeof last4 === 'string' && last4.length === 4) {
        commit('SET_ORDER_PAYMENT_SOURCE_LAST4', last4)
      }
    },

    setOrderPaymentSourceBrand ({ commit }, brand) {
      commit('SET_ORDER_PAYMENT_SOURCE_BRAND', brand)
    },

    setIsCountrySet ({ commit }, isCountrySet) {
      commit('SET_IS_COUNTRY_SET', isCountrySet)
    },

    clearCheckout ({ commit }) {
      commit('CLEAR_VOUCHER')
      commit('CLEAR_GIFT_CARD')
      commit('CLEAR_SOFT')
    },

    clearCheckoutSoft ({ commit }, force) {
      commit('CLEAR_SOFT', force)
    }
  },

  getters: {
    checkoutEmail (state) { return state.email },
    checkoutEmailIsValid (state) { return emailRE.test(state.email) },
    checkoutFirstName (state) { return state.firstName },
    checkoutLastName (state) { return state.lastName },
    checkoutPhoneMobile (state) { return state.phoneMobile },
    checkoutPhoneMobileRegion (state) { return state.phoneMobileRegion },
    checkoutPhoneMobileIsValid (state) {
      try {
        let pn = LibPhonenumber.PhoneNumberUtil.getInstance().parse(state.phoneMobile, state.phoneMobileRegion.region)
        if (!pn) {
          return false
        }
        return LibPhonenumber.PhoneNumberUtil.getInstance().isValidNumber(pn)
      } catch (e) {
        return false
      }
    },
    checkoutAddress (state) { return state.address },
    checkoutCity (state) { return state.city },
    checkoutCountry (state) { return state.country },
    checkoutState (state) { return state.state },
    checkoutPostalCode (state) { return state.postalCode },
    checkoutSeparateDeliveryAddress (state) { return state.separateDeliveryAddress },
    checkoutRememberMe (state) { return state.rememberMe },
    checkoutDeliveryEmail (state) { return state.deliveryEmail },
    checkoutDeliveryEmailIsValid (state) { return emailRE.test(state.deliveryEmail) },
    checkoutDeliveryPhoneMobile (state) { return state.deliveryPhoneMobile },
    checkoutDeliveryPhoneMobileRegion (state) { return state.deliveryPhoneMobileRegion },
    checkoutDeliveryPhoneMobileIsValid (state) {
      try {
        let pn = LibPhonenumber.PhoneNumberUtil.getInstance().parse(state.deliveryPhoneMobile, state.deliveryPhoneMobileRegion.region)
        if (!pn) {
          return false
        }
        return LibPhonenumber.PhoneNumberUtil.getInstance().isValidNumber(pn)
      } catch (e) {
        return false
      }
    },
    checkoutDeliveryFirstName (state) { return state.deliveryFirstName },
    checkoutDeliveryLastName (state) { return state.deliveryLastName },
    checkoutDeliveryAddress (state) { return state.deliveryAddress },
    checkoutDeliveryCity (state) { return state.deliveryCity },
    checkoutDeliveryCountry (state) { return state.deliveryCountry },
    checkoutDeliveryState (state) { return state.deliveryState },
    checkoutDeliveryPostalCode (state) { return state.deliveryPostalCode },
    shippingMethods (state) {
      return shippingMethods
    },
    shippingMethod (state, getters) {
      if (!getters.onlyGiftCardsInCart && state.shippingMethod === 'express') {
        return shippingMethods.express
      }
      return shippingMethods.standard
    },
    shippingCost (state, getters) {
      if (getters.onlyGiftCardsInCart) {
        return shippingMethods.standard.prices[getters.currency.currency]
      }
      return getters.shippingMethod.prices[getters.currency.currency]
    },
    orderItems (state, getters) {
      let items = []
      getters.cartItems.forEach(function (item) {
        if (item.product && item.product.category === 'giftCard') {
          for (let i = 0; i < item.count; i += 1) {
            items.push(buildOrderItem(item, true))
          }
        } else {
          items.push(buildOrderItem(item))
        }
      })

      if (getters.voucherIsApplicable === true) {
        const includeProducts = state.voucher.includeProducts
        const excludeProducts = state.voucher.excludeProducts
        const voucherAmount = state.voucher.amounts.find(
          x => x.currencyCode.toLowerCase() === getters.currency.currency.toLowerCase()
        )
        if (state.voucher.discountType === 'percentage') {
          items.forEach(function (item) {
            const productId = item.product ? item.product.id.toLowerCase() : item.id.toLowerCase()
            if (excludeProducts.indexOf(productId) < 0 &&
              (includeProducts.length < 1 || includeProducts.indexOf(productId) > -1)) {
              item.totalIncVat = item.subtotalIncVat * ((100 - state.voucher.percentage) / 100)
            }
          })
        } else if (state.voucher.discountType === 'fixed_cart') {
          if (voucherAmount) {
            let eligibleProducts = []
            let eligibleAmount = 0
            let totalDiscount = 0
            items.forEach(function (item) {
              const productId = item.product ? item.product.id.toLowerCase() : item.id.toLowerCase()
              if (excludeProducts.indexOf(productId) < 0 &&
                (includeProducts.length < 1 || includeProducts.indexOf(productId) > -1)) {
                eligibleProducts.push(item)
                eligibleAmount += item.subtotalIncVat
              }
            })
            eligibleProducts.forEach(function (item) {
              const discount = Math.round((item.subtotalIncVat / eligibleAmount) * voucherAmount.amount)
              item.totalIncVat = Math.min(item.subtotalIncVat, Math.max(0, item.subtotalIncVat - discount))
              totalDiscount += item.subtotalIncVat - item.totalIncVat
            })
            if (voucherAmount.amount < eligibleAmount) {
              if (eligibleProducts.length > 0) {
                eligibleProducts[eligibleProducts.length - 1].totalIncVat += totalDiscount - voucherAmount.amount
              }
            }
          }
        } else if (state.voucher.discountType === 'fixed_product') {
          if (voucherAmount) {
            items.forEach(function (item) {
              const productId = item.product ? item.product.id.toLowerCase() : item.id.toLowerCase()
              if (excludeProducts.indexOf(productId) < 0 &&
                (includeProducts.length < 1 || includeProducts.indexOf(productId) > -1)) {
                const discount = item.quantity * voucherAmount.amount
                item.totalIncVat = Math.min(item.subtotalIncVat, Math.max(0, item.subtotalIncVat - discount))
              }
            })
          }
        }
      }

      return items
    },
    grandTotal (state, getters) {
      return getters.cartSubTotal + getters.shippingCost - getters.voucherEffectiveAmount
    },
    vat (state, getters) {
      let vat = {
        poster: 0,
        default: 0
      }
      const shippingCountry = state.separateDeliveryAddress ? state.deliveryCountry : state.country
      if (shippingCountry !== null && shippingCountry !== '') {
        if (vatValues.hasOwnProperty(shippingCountry.toLowerCase())) {
          vat = vatValues[shippingCountry.toLowerCase()]
        }
      }
      let ret = getters.shippingCost - getters.shippingCost / (1.0 + vat.default)
      getters.orderItems.forEach((item) => {
        let category = 'poster'
        if (item.product.category) {
          category = item.product.category
        }
        if (vat.hasOwnProperty(category)) {
          ret += item.totalIncVat - item.totalIncVat / (1.0 + vat[category])
        } else if (vat.hasOwnProperty('default')) {
          ret += item.totalIncVat - item.totalIncVat / (1.0 + vat.default)
        }
      })
      return ret
    },

    voucher (state) { return state.voucher },

    voucherIsApplicable (state, getters) {
      if (state.voucher.isValid) {
        if (state.voucher.minimumSpend === undefined ||
          state.voucher.minimumSpend.length === 0) {
          return true
        }
        const amount = state.voucher.minimumSpend.find(
          x => x.currencyCode.toLowerCase() === getters.currency.currency.toLowerCase()
        )
        if (amount) {
          if (getters.cartSubTotal >= amount.amount) {
            return true
          }
        }
      }
      return false
    },

    giftCard (state) { return state.giftCard },

    giftCardIsApplicable (state, getters) {
      if (state.giftCard.isValid) {
        const amount = state.giftCard.amounts.find(
          x => x.currencyCode.toLowerCase() === getters.currency.currency.toLowerCase()
        )
        return amount && amount.balance > 0
      }
      return false
    },

    voucherEffectiveAmount (state, getters) {
      let ret = 0
      getters.orderItems.forEach((item) => {
        ret += item.subtotalIncVat - item.totalIncVat
      })
      return ret
    },

    giftCardEffectiveAmount (state, getters) {
      let ret = 0
      if (getters.giftCardIsApplicable === true) {
        const includeProducts = state.giftCard.includeProducts
        const excludeProducts = state.giftCard.excludeProducts
        const giftCardAmount = state.giftCard.amounts.find(
          x => x.currencyCode.toLowerCase() === getters.currency.currency.toLowerCase()
        )
        if (giftCardAmount) {
          let eligibleAmount = 0
          getters.orderItems.forEach(function (item) {
            const productId = item.product ? item.product.id.toLowerCase() : item.id.toLowerCase()
            if (excludeProducts.indexOf(productId) < 0 &&
              (includeProducts.length < 1 || includeProducts.indexOf(productId) > -1)) {
              eligibleAmount += item.totalIncVat
            }
          })
          ret = Math.min(giftCardAmount.balance, eligibleAmount)
        }
      }
      return ret
    },

    paymentAmount (state, getters) {
      let amount = getters.shippingCost
      getters.orderItems.forEach((item) => {
        amount += item.totalIncVat
      })
      return amount - getters.giftCardEffectiveAmount
    },

    orderState (state) { return state.orderState },
    orderId (state) { return state.orderId },
    orderConfirmationNumber (state) {
      return state.orderConfirmationNumber
    },
    orderPaymentSourceLast4 (state) { return state.orderPaymentSourceLast4 },
    orderPaymentSourceBrand (state) { return state.orderPaymentSourceBrand },
    isCountrySet (state) { return state.isCountrySet },

    onlyGiftCardsInCart (state, getters) {
      let onlyGiftCards = true
      getters.cartItems.forEach(function (item) {
        if (item.product) {
          if (item.product.category !== 'giftCard') {
            onlyGiftCards = false
          }
        } else {
          onlyGiftCards = false
        }
      })
      return getters.cartItems.length > 0 && onlyGiftCards
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/checkout.js